export default __webpack_public_path__ + "static/participate4-495f8a8afb2e57cf3bb33c72b520ebf6.png";